(() => {
  const labelMap = new Map([
    ['movimento', 'movement'], ['tipo movimento', 'movement'],
    ['diametro', 'diameter'], ['diametro cassa', 'diameter'], ['diametro della cassa', 'diameter'],
    ['vetro', 'glass'], ['tipo di vetro', 'glass'],
    ['impermeabilità', 'water'], ['resistenza all’acqua', 'water'],
    ["resistenza all'acqua", 'water'], ['resistente all’acqua', 'water'],
    ["resistente all'acqua", 'water'], ['resistenza acqua', 'water'],
    ['include', 'package'], ['confezione', 'package'], ['dotazione', 'package'],
    ['garanzia', 'warranty']
  ]);
  function normalize(label) {
    return label.toLowerCase().replace(/[():ø]/g, '').replace(/\s+/g, ' ').trim();
  }
  function collectFacts(source) {
    const facts = new Map();
    function put(label, value) {
      const key = labelMap.get(normalize(label));
      value = value.replace(/\s+/g, ' ').split(' — ')[0].trim();
      if (key && value && value.length <= 180 && !facts.has(key)) facts.set(key, value);
    }
    const clone = source.cloneNode(true);
    clone.querySelectorAll('script,style').forEach(node => node.remove());
    clone.querySelectorAll('br').forEach(node => node.replaceWith(document.createTextNode('\n')));
    clone.querySelectorAll('tr').forEach(row => {
      const cells = row.querySelectorAll('th,td');
      if (cells.length === 2) put(cells[0].textContent, cells[1].textContent);
    });
    clone.querySelectorAll('li,p').forEach(node => {
      node.textContent.split('\n').forEach(line => {
        line = line.replace(/^[^\p{L}\p{N}]+/u, '').trim();
        const match = line.match(/^([^:]{2,45}):\s*(.+)$/u);
        if (match) put(match[1], match[2]);
        const warranty = line.match(/^Garanzia\s+(\d+\s+(?:mesi|anni))\s*$/iu);
        if (warranty) put('garanzia', warranty[1]);
      });
    });
    return facts;
  }
  function enhance(scope) {
    scope.querySelectorAll('[data-paoma-insights]').forEach(panel => {
      const page = panel.closest('.product-page');
      const source = page && page.querySelector('.product-blocks__block--description');
      if (!source) return;
      const facts = collectFacts(source);
      panel.querySelectorAll('[data-paoma-fact]').forEach(item => {
        const value = facts.get(item.dataset.paomaFact);
        item.hidden = !value;
        if (value) item.querySelector('dd').textContent = value;
      });
      panel.querySelector('[data-paoma-facts]').hidden = facts.size === 0;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(document), {once: true});
  else enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
